import React, { useState } from "react";
import { Link } from "react-router-dom";
import { submitContact } from "../lib/api";
import Logo from "./Logo";

const Footer = () => {
  const [open, setOpen] = useState(null); // 'suggest' | 'contact' | null
  const [form, setForm] = useState({ sender_name: "", sender_email: "", message_body: "", subject: "" });
  const [status, setStatus] = useState("idle");

  const send = async (source) => {
    if (!form.message_body.trim()) return;
    setStatus("sending");
    // Map UI modal key -> backend source whitelist
    const apiSource = source === "contact" ? "contact_us" : source;
    try {
      await submitContact({
        ...form,
        sender_email: form.sender_email || null,
        sender_name: form.sender_name || null,
        source: apiSource,
        category: source === "suggest" ? "suggestion" : "general",
      });
      setStatus("sent");
      setForm({ sender_name: "", sender_email: "", message_body: "", subject: "" });
      setTimeout(() => { setOpen(null); setStatus("idle"); }, 1800);
    } catch (e) {
      setStatus("error");
    }
  };

  return (
    <footer
      data-testid="site-footer"
      style={{
        background: "#0A1628",
        color: "#fff",
        padding: "44px 24px 28px",
        marginTop: 60,
        borderTop: "3px solid #D4AF37",
      }}
    >
      <div style={{ maxWidth: 1180, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 24 }}>
        <div>
          <div style={{ marginBottom: 18 }}>
            <Logo variant="light" size={56} testId="footer-logo" />
          </div>
          <p style={{ fontSize: 16, color: "#cbd0db", lineHeight: 1.5 }}>
            Market Your Business Automatically.<br />Find. Book. Now.
          </p>
        </div>

        <div>
          <h4 className="font-display" style={{ fontSize: 22, color: "#D4AF37", letterSpacing: 2 }}>For Contractors</h4>
          <Link to="/onboard-simple" data-testid="footer-onboard" style={footLink}>Add Your Business (5 min)</Link>
          <Link to="/pricing" data-testid="footer-pricing" style={footLink}>Pricing</Link>
          <Link to="/available-today" data-testid="footer-available-today" style={footLink}>Available Today</Link>
        </div>

        <div>
          <h4 className="font-display" style={{ fontSize: 22, color: "#D4AF37", letterSpacing: 2 }}>For Workers</h4>
          <Link to="/available-today/join" data-testid="footer-worker-join" style={footLink}>Join as a Worker (free)</Link>
          <Link to="/available-today/me" data-testid="footer-worker-me" style={footLink}>Edit My Profile</Link>
        </div>

        <div>
          <h4 className="font-display" style={{ fontSize: 22, color: "#D4AF37", letterSpacing: 2 }}>Help</h4>
          <button
            data-testid="footer-suggest-btn"
            onClick={() => setOpen("suggest")}
            style={{ ...footLinkBtn }}
          >
            Have a Suggestion?
          </button>
          <button
            data-testid="footer-contact-btn"
            onClick={() => setOpen("contact")}
            style={{ ...footLinkBtn }}
          >
            Contact Us
          </button>
        </div>

        <div>
          <h4 className="font-display" style={{ fontSize: 22, color: "#D4AF37", letterSpacing: 2 }}>Service Area</h4>
          <p style={{ ...footMeta }}>Rhode Island</p>
          <p style={{ ...footMeta }}>Massachusetts — Coming Soon</p>
          <p style={{ ...footMeta, marginTop: 16, fontSize: 14, color: "#8a8d96" }}>
            contact@nearnow.biz
          </p>
        </div>
      </div>

      <div style={{ borderTop: "1px solid #1a2640", marginTop: 32, paddingTop: 18, textAlign: "center", color: "#8a8d96", fontSize: 14 }}>
        — Powered by NearNow | Market Your Business Automatically<br />
        © 2026 NearNow.Biz / AIH LLC
      </div>

      {open && (
        <div
          data-testid={`${open}-modal`}
          onClick={() => setOpen(null)}
          style={{
            position: "fixed", inset: 0, background: "rgba(10,22,40,0.85)",
            display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100, padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", color: "#1A1A2E", borderRadius: 10, maxWidth: 540, width: "100%", padding: 28 }}
          >
            <h3 className="font-display" data-testid={`${open}-title`} style={{ fontSize: 36, color: "#0A1628", marginTop: 0 }}>
              {open === "suggest" ? "Share an Idea" : "Contact Us"}
            </h3>
            <p style={{ marginTop: -8, color: "#5a5d66" }}>
              {open === "suggest"
                ? "Tell us what would make NearNow better. Anonymous is OK."
                : "Real humans read every message. We reply within 24 hours."}
            </p>

            <label className="nn-label">Name {open === "suggest" ? "(optional)" : ""}</label>
            <input
              data-testid={`${open}-name`}
              className="nn-input"
              value={form.sender_name}
              onChange={(e) => setForm({ ...form, sender_name: e.target.value })}
              placeholder="Your name"
            />

            <label className="nn-label" style={{ marginTop: 14 }}>Email {open === "suggest" ? "(optional)" : ""}</label>
            <input
              data-testid={`${open}-email`}
              type="email"
              className="nn-input"
              value={form.sender_email}
              onChange={(e) => setForm({ ...form, sender_email: e.target.value })}
              placeholder="you@example.com"
            />

            {open === "suggest" && (
              <>
                <label className="nn-label" style={{ marginTop: 14 }}>Idea title</label>
                <input
                  data-testid="suggest-subject"
                  className="nn-input"
                  value={form.subject}
                  onChange={(e) => setForm({ ...form, subject: e.target.value })}
                  placeholder="One short line"
                  maxLength={80}
                />
              </>
            )}

            <label className="nn-label" style={{ marginTop: 14 }}>
              {open === "suggest" ? "What problem would this solve?" : "Your message"}
            </label>
            <textarea
              data-testid={`${open}-message`}
              className="nn-input"
              style={{ minHeight: 130, fontFamily: "DM Sans, sans-serif" }}
              value={form.message_body}
              onChange={(e) => setForm({ ...form, message_body: e.target.value })}
              maxLength={500}
              placeholder="Plain English. Real talk."
            />

            <div style={{ display: "flex", gap: 12, marginTop: 18, flexWrap: "wrap" }}>
              <button
                data-testid={`${open}-submit`}
                className="btn-gold tap"
                onClick={() => send(open)}
                disabled={status === "sending" || !form.message_body.trim()}
              >
                {status === "sending" ? "SENDING..." : status === "sent" ? "SENT!" : "SEND"}
              </button>
              <button
                data-testid={`${open}-cancel`}
                className="btn-outline-navy tap"
                onClick={() => setOpen(null)}
              >
                CANCEL
              </button>
            </div>
            {status === "sent" && (
              <p data-testid={`${open}-success`} style={{ marginTop: 14, color: "#1A7A4A", fontWeight: 600 }}>
                We got it. Routes to contact@nearnow.biz.
              </p>
            )}
            {status === "error" && (
              <p data-testid={`${open}-error`} style={{ marginTop: 14, color: "#A32D2D", fontWeight: 600 }}>
                Couldn't send right now — please try again or email contact@nearnow.biz.
              </p>
            )}
            <p style={{ fontSize: 13, color: "#8a8d96", marginTop: 14 }}>
              <span className="mock-badge">MOCK</span> &nbsp; Email delivery via SendGrid will activate when key is set.
            </p>
          </div>
        </div>
      )}
    </footer>
  );
};

const footLink = {
  display: "block", color: "#cbd0db", textDecoration: "none",
  padding: "6px 0", fontSize: 16,
};
const footLinkBtn = {
  display: "block", color: "#cbd0db", textDecoration: "underline",
  padding: "6px 0", fontSize: 16, background: "transparent", border: "none",
  cursor: "pointer", textAlign: "left", fontFamily: "DM Sans, sans-serif",
};
const footMeta = { color: "#cbd0db", fontSize: 16, margin: "6px 0" };

export default Footer;
